export const blogData = [
    {
        link : "https://blog.saeloun.com/2023/08/11/2023-ECMAScript-2023-new-features/",
        title: "ECMAScript 2023 - Exploring New Features",
        image: require("../images/Blog/ECMAscript.png"),
        summary: "In this blog, we'll dive into the ECMAScript 2023 updates, highlighting four significant new features that promise to streamline our coding experience."

    },
    {
        link : "https://blog.saeloun.com/2023/09/13/react-Zustand-vs-Redux/",
        title: "Zustand or Redux, which one is the best choice?",
        image: require("../images/Blog/ZustandVsRedux.png"),
        summary: "This blog explores Zustand and Redux for React state management, highlighting Zustand's simplicity and Redux's suitability for complex projects."

    },
    {
        link : "https://blog.saeloun.com/2024/01/08/tailwind-vs-bootstrap/",
        title: "Tailwind vs Bootstrap",
        image: require("../images/Blog/TailwindVsBootstrap.jpeg"),
        summary: "This blog explores the differences between Tailwind CSS and Bootstrap, assisting developers in selecting the optimal framework for their projects."

    },
    {
        link : "https://blog.saeloun.com/2023/07/06/react-error-boundaries/",
        title: "React error handling with react-error-boundary",
        image: require("../images/Blog/errorBoundary.png"),
        summary: "React error boundaries provide a way to gracefully handle runtime errors and prevent them from crashing the entire application."

    },
    {
        link : "https://blog.saeloun.com/2022/09/02/css-parent-selector-has/",
        title: "Understanding the CSS parent selector :has()",
        image: require("../images/Blog/has_selector.png"),
        summary: "If we want to target the parent element based on the content or the child elements we can use :has()."

    },
    {
        link : "https://blog.saeloun.com/2023/05/11/writing-resusable-code-with-react-composition/",
        title: "Writing re-usable code with React Composition",
        image: require("../images/Blog/lego.jpeg"),
        summary: "React Composition helps make our code more efficient, and easier to maintain and update in the long run. Instead of relying on one big component to do everything, we break it down into smaller parts, so we can reuse them in other places, and build even more complex components."

    }
]